import { Outlet } from 'react-router-dom';
import React, { PropsWithChildren } from 'react';
import { AppFooter } from '../footer';
import styles from './content.module.scss';
import { AppBreadcrumbs } from 'common/layout/components/breadcrumbs';

export const AppContent = ({children}: PropsWithChildren) => {
  return (
	<div className={styles.content}>
	  <AppBreadcrumbs/>
	  <div className={styles.pageWrapper}>
		<Outlet/>
	  </div>
	  <AppFooter />
	</div>
  );
};
